import { render, staticRenderFns } from "./routeDetail.vue?vue&type=template&id=39971ea2&"
import script from "./routeDetail.vue?vue&type=script&lang=js&"
export * from "./routeDetail.vue?vue&type=script&lang=js&"
import style0 from "./routeDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports